module.exports = __webpack_public_path__ + "img/second-prize.e950ed11.png";